export interface ParsedSharedLedgerPathRoute {
  shareId: string
}

export const buildSharedLedgerPath = (shareId: string): string => (
  `/shared-ledgers/${encodeURIComponent(shareId)}`
)

export const parseSharedLedgerPath = (pathname: string): ParsedSharedLedgerPathRoute | null => {
  const segments = (pathname || '').split('/').filter(Boolean)
  if (segments.length === 2 && segments[0] === 'shared-ledgers') {
    return { shareId: decodeURIComponent(segments[1]) }
  }
  return null
}
